import React, { forwardRef } from 'react';
import { Row, Col, TimePicker, Button } from 'antd';
import moment from 'moment';

const TimePickerRange = (props, ref) => {
    const {
        prefixCls,
        className,
        style,
        onChange,
        value,
        disabled,
        type,
        ...rest
    } = props;

    const [startTime, setStartTime] = React.useState();
    const [endTime, setEndTime] = React.useState();
    const [open1, setOpen1] = React.useState(false);
    const [open2, setOpen2] = React.useState(false);
    /*定义时间数组*/
    const Hours = Array.from(Array(24), (v, k) => k);
    const Minutes = Array.from(Array(60), (v, k) => k);
    const Seconds = Array.from(Array(60), (v, k) => k);

    const triggerChange = changedValue => {
        console.log('changedValue', changedValue)
    };

    /*结束时间控制-hour*/
    const disEndHouse = () => {
        if (startTime) {
            let h = startTime.hour();
            return Hours.slice(0, h);
        }
        return [];
    };

    /*结束时间控制-minute）*/
    const disEndMinute = h => {
        if (startTime) {
            if (h > startTime.hour()) return [];
            let m = startTime.minute();
            return Minutes.slice(0, m);
        }
        return [];
    };

    /*结束时间控制-second*/
    const disEndSeconds = (h, m) => {
        if (startTime) {
            if (h > startTime.hour()) return [];
            if (m > startTime.minute()) return [];
            let s = startTime.second();
            return Seconds.slice(0, s);
        }
        return [];
    };

    /*开始时间控制-hour*/
    const disStartHouse = () => {
        if (endTime) {
            let h = endTime.hour();
            return Hours.slice(h, Hours.length - 1);
        }
        return [];
    };

    /*开始时间控制-minute*/
    const disStartMinute = h => {
        if (endTime) {
            if (h < endTime.hour()) return [];
            let m = endTime.minute();
            return Minutes.slice(m, Minutes.length - 1);
        }
        return [];
    };

    /*开始时间控制-second*/
    const disStartSeconds = (h, m) => {
        if (endTime) {
            if (h < endTime.hour()) return [];
            if (m < endTime.minute()) return [];
            let s = endTime.second();
            return Seconds.slice(s, Seconds.length - 1);
        }
        return [];
    };

    const handleClose1 = () => {
        console.log('startTime', startTime)
        setOpen1(false)
        if (!onChange) return;
        onChange({
            start: startTime ? startTime.format('HH:mm:ss') : '',
            type
        });
    };

    const handleClose2 = () => {
        console.log('endTime', endTime)
        setOpen2(false)
        if (!onChange) return;
        onChange({ end: endTime ? endTime.format('HH:mm:ss') : '', type });
    };

    const handleOpenChange1 = (open1) => {
        console.log('open1', open1)
        if (open1 == true) {
            handleClose2();
            setOpen1(open1)
        }
    }


    const handleOpenChange2 = (open2) => {
        if (open2 == true) {
            handleClose1();
            setOpen2(open2);
        }
    }
    return (
        <div className='timePickerRange'>
            <TimePicker
                open={open1}
                onOpenChange={handleOpenChange1}
                placeholder={type == 'lotterySearchCondition' ? '领取开始时间' : type == 'guideListSearchCondition' ? '激活开始时间' : '开始时间'}
                allowClear={false}
                disabled={disabled}
                onChange={value => {
                    setStartTime(value);
                }}
                value={startTime}
                disabledHours={disStartHouse}
                disabledMinutes={disStartMinute}
                disabledSeconds={disStartSeconds}
                addon={() => (
                    <Button size="small" type="primary" onClick={handleClose1}>确定</Button>
                )}
            />
            <TimePicker
                open={open2}
                onOpenChange={handleOpenChange2}
                placeholder={type == 'lotterySearchCondition' ? '领取结束时间' : type == 'guideListSearchCondition' ? '激活结束时间' : '结束时间'}
                allowClear={false}
                disabled={disabled}
                onChange={value => {
                    setEndTime(value);
                }}
                value={endTime}
                disabledHours={disEndHouse}
                disabledMinutes={disEndMinute}
                disabledSeconds={disEndSeconds}
                addon={() => (
                    <Button size="small" type="primary" onClick={handleClose2}>确定</Button>
                )}
            />
        </div>

    );
};

export default forwardRef(TimePickerRange);